import React from "react";

function PartialView({ children }) {
  return <>{children}</>;
}

export default PartialView;
